import React from 'react'
import { AiFillCheckCircle, AiOutlineClose } from 'react-icons/ai';
import { BudgetSchedule, CampaignAudience, Placements } from '../..';

const CampaignAwareness: React.FC = () => {
  return (
    <div className='w-full flex flex-col gap-10 font-Poppins'>
      <div className="flex justify-center bg-white text-[#555]  rounded-lg p-8 pb-16 flex-col gap-10 shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)] ">
        <div className="flex gap-2 items-center">
          <AiFillCheckCircle className='fill-green-500'/>
          <h1 className='font-semibold text-lg'>Awareness</h1>
        </div>
        <div className="pl-6 pr-12">
          <div className="border border-l-[5px] font-Poppins bg-[#CCCCCC1A] border-l-[#000] px-[30px] py-6 rounded-[10px] ">
            <div className="border-b border-solid border-b-[#CCC] pb-5">
              <div className="flex justify-between items-center">
                <h3 className='text-base font-semibold text-[#555]'>
                  Introducing performance goal
                </h3>
                <AiOutlineClose className='cursor-pointer'/>
              </div>
              <div className="text-[#727272] flex flex-col gap-2 text-sm font-normal mt-5">
                <p>
                  Formerly called optimization for ad delivery,
                  your performance goal helps us understand 
                  what outcomes you want to drive with your ads.
                  Then we can look for the best opportunities 
                  to support those outcomes.
                </p>
                <p>
                  All optimization options are now available
                  under performance goal. These and other 
                  optimization and delivery setting 
                  are now part of conversion setup.
                </p>
              </div>
            </div>
            <h3 className='text-xs font-normal text-midGreen mt-5'>About ad delivery</h3>
          </div>
        </div>

        <div className="grid gap-1">
          <h1 className='font-semibold text-base'>Performance goals</h1>
          <input 
            type="text"
            placeholder='Maximize reach of ads'
            className='w-full h-11 pl-5 py-3 border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
          />
          <p className='text-[#727272] text-xs font-normal'>
            To help us improve delivery, 
            we may survey a small section of your audience.
          </p>
        </div>

        <div className="grid gap-1">
          <h1 className='font-semibold text-base'>EcoMoto Community</h1>
          <input 
            type="text"
            placeholder='Enter EcoMoto Community'
            className='w-full h-11 pl-5 py-3 border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
          />
        </div>

        <div className="grid gap-1">
          <h1 className='font-semibold text-base'>Bid control</h1>
          <div
            className='w-full h-11 px-5 py-3 flex justify-between border-[#CCC] border-solid border rounded-lg text-[#CCC] font-Poppins font-normal text-xs' 
          >
            <h5>$2.00</h5> <h5>USD</h5>
          </div>
          <p className='text-[#727272] text-xs font-normal'>
            Maximum bid in each auction
          </p>
        </div>

        <p className='text-sm font-normal'>
          Orokii will aim to get the most 1,000 impressions without
          bidding more than $2.00 in any auction using the bid cap bid strategy.
        </p>
      </div>
      <BudgetSchedule/>
      <CampaignAudience/>
      <Placements/>
      <div className="flex justify-between mt-5">
        <div className="flex bg-[#CEC7F866] items-center justify-center font-semibold text-sm text-black rounded w-[123px] h-12">
          Cancel
        </div>
        <div className="flex bg-midGreen items-center justify-center font-semibold text-sm text-white rounded w-[123px] h-12">
          Next
        </div>
      </div>
    </div>
  )
}

export default CampaignAwareness;